import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./i18n/i18n";
import "./i18n/home";
import "./styles/ui.css";

const root = createRoot(document.getElementById("root")!);

// The room page loads the media controller only after access is granted.
root.render(<App />);
